import React, { useState } from 'react';
const TABS = ['Overview', 'Specs', 'Options', 'PDFs / Downloads', 'Compatibility / USPS Notes', 'Reviews'];
const SPECS: [string, string][] = [['Total Tenant Doors', '20'], ['Tenant Door Height', '3.00"'], ['Total Parcel Lockers', '2'], ['Height', '72 1/16"'], ['Width', '32 11/16"'], ['Depth', '18"']];
export function ProductDescription() {
  const [activeTab, setActiveTab] = useState('Overview');
  return <div className="mt-16 border-t border-brand-border pt-12" data-id="element-651" data-mp="19jyt0hvpy3ef">
      {/* Tabs Header */}
      <div className="flex overflow-x-auto hide-scrollbar border-b border-brand-border mb-8" role="tablist" data-id="element-652" data-mp="1eg5nneinzsh2">
        {TABS.map(tab => <button key={tab} type="button" role="tab" aria-selected={activeTab === tab} onClick={() => setActiveTab(tab)} className={`px-6 py-3 text-sm font-bold whitespace-nowrap border-b-2 transition-colors ${activeTab === tab ? 'border-brand-maroon text-brand-maroon' : 'border-transparent text-gray-500 hover:text-brand-charcoal hover:border-gray-300'}`} data-id="element-653" data-mp="14qdveqy1fbfr">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="max-w-none" data-id="element-654" data-mp="2vtbm8y183hna">
        {activeTab === 'Overview' && <div className="prose max-w-none text-gray-700 leading-relaxed" data-id="element-655" data-mp="2qzzavplk17ch">
            <p data-id="element-656" data-mp="35pezp01iz2pj">
              The Depot is a freestanding solution that provides flexibility to
              install STD-4C wall-mounted mailboxes in a standalone cabinet.
              This option is designed for private delivery applications and is
              not approved for USPS Delivery.
            </p>
          </div>}

        {activeTab === 'Specs' && <div className="bg-white rounded-xl border border-brand-border overflow-hidden" data-id="element-657" data-mp="1kclo826ydw4r">
            <table className="w-full text-sm text-left" data-id="element-658" data-mp="1keewflx7soev">
              <tbody className="divide-y divide-brand-border" data-id="element-659" data-mp="1gcbimqn2p7qf">
                {SPECS.map(([label, value], i) => <tr key={label} className={i % 2 === 0 ? 'bg-brand-cream/30' : ''} data-id="element-660" data-mp="3fhl0lmwcigos" data-mpi={i}>
                    <th className="px-6 py-4 font-bold text-brand-charcoal w-1/3" data-id="element-661" data-mp="3pe7nsic59jtz">
                      {label}
                    </th>
                    <td className="px-6 py-4 text-gray-700" data-id="element-662" data-mp="3udsjmjw0pc2h">{value}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>}

        {activeTab === 'Options' && <div className="space-y-6 text-gray-700" data-id="element-663" data-mp="76i6uls9865j">
            <div data-id="element-664" data-mp="byi2i21akcwb">
              <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-665" data-mp="c02xfsripxup">
                4C Depot Color Options
              </h3>
              <p className="text-sm leading-relaxed" data-id="element-666" data-mp="gxcqdie48rna">
                Choose from Dark Bronze, Black, Gold Speck, Postal Grey,
                Sandstone, Silver Speck, White, or Antique Bronze. The selected
                finish updates the product image so you can confirm the look
                before ordering.
              </p>
            </div>
            <div data-id="element-667" data-mp="26eqgj0z5ixzl">
              <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-668" data-mp="26e6vvci49vhv">
                Door Identification
              </h3>
              <p className="text-sm leading-relaxed" data-id="element-669" data-mp="21gov49e96mky">
                Select Standard Decal ID, Non Standard Decal ID, or Engraved -
                No Fill ID. This determines how each tenant door is labeled.
              </p>
            </div>
            <div data-id="element-670" data-mp="2p5zsdgwe9yuc">
              <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-671" data-mp="2p5hn5urr8aaa">
                Door Sequence
              </h3>
              <p className="text-sm leading-relaxed" data-id="element-672" data-mp="2kdq5yauhngwt">
                Standard number will be sequential if none entered. Use the
                project notes field to provide a custom numbering sequence or
                special requirements.
              </p>
            </div>
          </div>}

        {activeTab === 'PDFs / Downloads' && <div className="bg-white rounded-xl border border-brand-border p-6 text-gray-600" data-id="element-673" data-mp="2smlvyxeokvwv">
            {/* TODO: wire to verified Website Forge product PDF assets */}
            <ul className="space-y-3 text-sm" data-id="element-674" data-mp="2wpifqrfyiy2e">
              <li className="flex items-center justify-between border-b border-brand-border/60 pb-3" data-id="element-675" data-mp="2ioxxbwdyf49f">
                <span className="font-medium text-brand-charcoal" data-id="element-676" data-mp="2nmpqetqc4wf7">
                  Product PDF
                </span>
                <span className="text-gray-400" data-id="element-677" data-mp="3beeoyrtr2h4l">
                  Pending Website Forge integration
                </span>
              </li>
              <li className="flex items-center justify-between" data-id="element-678" data-mp="3gdzmcxt9uhf7">
                <span className="font-medium text-brand-charcoal" data-id="element-679" data-mp="31mr274851o9g">
                  PDF Line Drawings
                </span>
                <span className="text-gray-400" data-id="element-680" data-mp="36kaisasb6d4k">
                  Pending Website Forge integration
                </span>
              </li>
            </ul>
          </div>}

        {activeTab === 'Compatibility / USPS Notes' && <div className="bg-red-50 p-6 rounded-xl border border-red-200" data-id="element-681" data-mp="1nmw0rb8n9gdu">
            <h3 className="text-brand-red font-bold mb-4" data-id="element-682" data-mp="1iom7j66hcpuv">
              USPS Delivery Compliance
            </h3>
            <p className="text-red-900 mb-4" data-id="element-683" data-mp="1wgiqokq67pf4">
              This freestanding Depot installation is{' '}
              <strong data-id="element-684" data-mp="1se5mw1uzi1kz">not approved for USPS Delivery</strong>. The Depot
              provides flexibility to install STD-4C wall-mounted mailboxes in a
              standalone cabinet for private delivery applications.
            </p>
            <p className="text-red-900" data-id="element-685" data-mp="zrb91nsoa0gh">
              Confirm your delivery use and project requirements before
              ordering. If you require USPS delivery, shop our standard
              wall-mounted or pedestal-mounted CBU systems and consult your
              local Postmaster before installation.
            </p>
          </div>}

        {activeTab === 'Reviews' && <div className="p-6 text-center text-gray-600 border border-dashed border-brand-border rounded-xl" data-id="element-686" data-mp="2k51zd1d4u47q">
            Nobody has rated this product yet.
          </div>}
      </div>
    </div>;
}